import Layout2 from '@/layout/Layout2';
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
  path: '/shop_waiter',
  component: Layout2,
  children: [
    {
      path: '',
      name: 'shopWaiterDetail',
      component: () => import(/* webpackChunkName: "jp.shop" */ '@/merchanAdmin/shopdetail/child/waiter/detail'),
      meta: {
        // zhtitle: '人员编辑',
        // jatitle: '人员編集',
        zhtitle: zh.m.content.shop.WAITER_EDIT,
        jatitle: ja.m.content.shop.WAITER_EDIT,
        pername: "shop_setting"
      },
    }
  ]
}]
